export default __webpack_public_path__ + "static/media/stage1.7d6cad88.jpg";